export default {
  title: 'Dziękujemy za przesłanie danych w celu otrzymywania płatności',
  description:
    'Weryfikacja przez Stripe może potrwać do 48 godzin. W międzyczasie możesz przejść do kolejnych kroków. Poinformujemy Cię e-mailem, gdy Twoje dane zostaną potwierdzone.',
};
